import {
    TypeaheadObjectContainer,
} from '../Typeahead'

import {
    LocationSelectorDefaultProps,
    LocationObjectSelectorProps,
} from './types/LocationSelector.types'
import BaseLocationSelector from './BaseLocationSelector'

const LocationObjectDataSelector = ({
    value,
    onChange,
    name,
    title,
    disabled,
    isRequired,
    className,
    classNames,
    filterLocationType,
    filterByCompanyId,
    isApprovedSubContractor,
    'data-testid': dataTestId,
    validate,
    setErrors,
    allowedLocationTypes,
    isShippingLocation,
    actionLinkFunction,
}: LocationObjectSelectorProps) => {
    return (
        <BaseLocationSelector
            searchComponent={TypeaheadObjectContainer}
            value={value?.id}
            onChange={onChange}
            name={name}
            title={title}
            disabled={disabled}
            isRequired={isRequired}
            className={className}
            classNames={classNames}
            filterByCompanyId={filterByCompanyId}
            filterLocationType={filterLocationType}
            isApprovedSubContractor={isApprovedSubContractor}
            data-testid={dataTestId}
            validate={validate}
            setErrors={setErrors}
            allowedLocationTypes={allowedLocationTypes}
            isShippingLocation={isShippingLocation}
            actionLinkFunction={actionLinkFunction}
        />
    )
}

LocationObjectDataSelector.defaultProps = LocationSelectorDefaultProps

export default LocationObjectDataSelector
